import { createSlice } from '@reduxjs/toolkit';
import { getFilteredSizes, getShowcaseFeeds } from './thunk';
import { resetUploadState } from '../uploads/reducer';

export const initialState = {
  selectedShowcaseVersion: null,
  bannerFilter: null,
  showcaseSizes: null,
  selectedSizes: [],
  password: null,
  showcaseLink: null,
  showcaseId: null,
  versionIds: null,
  sendLinkViaEmail: { addresses: '', message: '' },
  showcaseCreatives: null,
}

const showcaseSlice = createSlice({
  name: 'Showcase',
  initialState,
  reducers: {
    setSelectedShowcaseVersion(state, action) {
      state.selectedShowcaseVersion = action.payload;
    },
    setBannerFilter(state, action) {
      state.bannerFilter = action.payload;
    },
    setShowcaseSizes(state, action) {
      state.showcaseSizes = action.payload;
    },
    setSelectedSizes(state, action) {
      state.selectedSizes = action.payload;
    },
    setShowcasePwd(state, action) {
      state.password = action.payload;
    },
    setShowcaseLink(state, action) {
      state.showcaseLink = action.payload;
    },
    setShowcaseId(state, action) {
      state.showcaseId = action.payload;
    },
    setVersionIds(state, action) {
      state.versionIds = action.payload;
    },
    setSendLinkViaEmail(state, action) {
      state.sendLinkViaEmail = action.payload;
    },
    setShowcaseCreatives(state, action) {
      state.showcaseCreatives = action.payload;
    },
    resetShowcaseState(state) {
      state.selectedShowcaseVersion = null;
      state.bannerFilter = null;
      state.showcaseSizes = null;
      state.selectedSizes = [];
      state.password = null;
      state.showcaseLink = null;
      state.showcaseId = null;
      state.versionIds = null;
      state.sendLinkViaEmail = { addresses: '', message: '' };
      state.showcaseCreatives = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getFilteredSizes.fulfilled, (state, action) => {
      state.showcaseSizes = action.payload;
    });
  }
});

export const {
  setSelectedShowcaseVersion,
  setBannerFilter,
  setShowcaseSizes,
  setSelectedSizes,
  setShowcasePwd,
  setShowcaseLink,
  setShowcaseId,
  setVersionIds,
  setSendLinkViaEmail,
  setShowcaseCreatives,
  resetShowcaseState
} = showcaseSlice.actions;

export default showcaseSlice.reducer;